import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { SerialNumbers_ShellService } from './SerialNumbers.shell.service';
import { SerialNumbers_OperationService } from './SerialNumbers.operation.service';
import { SerialNumbers_DatasourceService } from './SerialNumbers.datasource.index';
import { SerialNumbers_FlowService } from './SerialNumbers.flow.index';
import { SerialNumbers_ReportService } from './SerialNumbers.report.index';
import { SerialNumbers_LocalizationService } from './SerialNumbers.localization.service';
import { SerialNumbers_serialnumbers_lots_dd_ComponentContextService } from './SerialNumbers.serialnumbers_lots_dd.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './SerialNumbers.frontend.types'
import { $frontendTypes as $types} from './SerialNumbers.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'SerialNumbers-serialnumbers_lots_dd_multi',
  templateUrl: './SerialNumbers.serialnumbers_lots_dd_multi.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SerialNumbers_serialnumbers_lots_dd_multiComponent),
      multi: true
    }
  ]
})
export class SerialNumbers_serialnumbers_lots_dd_multiComponent extends BaseComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;

  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return true;
  }

  get isSingle() {
    return false;
  }


  inParams: { licenseplateIds?: number[], locationId?: number, warehouseIds?: number[], lotId?: number, materialIds?: number[], projectId?: number, ownerId?: number, archived?: boolean, fullTextSearch?: string, textSearch?: string, orderId?: number, orderLineNumber?: number } = { licenseplateIds: [], locationId: null, warehouseIds: [], lotId: null, materialIds: [], projectId: null, ownerId: null, archived: null, fullTextSearch: null, textSearch: null, orderId: null, orderLineNumber: null };
  @Input('licenseplateIds') set $inParams_licenseplateIds(value: any) {
    this.inParams['licenseplateIds'] = value;
  }
  get $inParams_licenseplateIds(): any {
    return this.inParams['licenseplateIds'] ;
  }
  @Input('locationId') set $inParams_locationId(value: any) {
    this.inParams['locationId'] = value;
  }
  get $inParams_locationId(): any {
    return this.inParams['locationId'] ;
  }
  @Input('warehouseIds') set $inParams_warehouseIds(value: any) {
    this.inParams['warehouseIds'] = value;
  }
  get $inParams_warehouseIds(): any {
    return this.inParams['warehouseIds'] ;
  }
  @Input('lotId') set $inParams_lotId(value: any) {
    this.inParams['lotId'] = value;
  }
  get $inParams_lotId(): any {
    return this.inParams['lotId'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('archived') set $inParams_archived(value: any) {
    this.inParams['archived'] = value;
  }
  get $inParams_archived(): any {
    return this.inParams['archived'] ;
  }
  @Input('fullTextSearch') set $inParams_fullTextSearch(value: any) {
    this.inParams['fullTextSearch'] = value;
  }
  get $inParams_fullTextSearch(): any {
    return this.inParams['fullTextSearch'] ;
  }
  @Input('textSearch') set $inParams_textSearch(value: any) {
    this.inParams['textSearch'] = value;
  }
  get $inParams_textSearch(): any {
    return this.inParams['textSearch'] ;
  }
  @Input('orderId') set $inParams_orderId(value: any) {
    this.inParams['orderId'] = value;
  }
  get $inParams_orderId(): any {
    return this.inParams['orderId'] ;
  }
  @Input('orderLineNumber') set $inParams_orderLineNumber(value: any) {
    this.inParams['orderLineNumber'] = value;
  }
  get $inParams_orderLineNumber(): any {
    return this.inParams['orderLineNumber'] ;
  }

  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: SerialNumbers_ShellService,
    private $datasources: SerialNumbers_DatasourceService,
    private $flows: SerialNumbers_FlowService,
    private $reports: SerialNumbers_ReportService,
    private $localization: SerialNumbers_LocalizationService,
    private $operations: SerialNumbers_OperationService,
    private $logger: CleanupLoggerService,
    private $context: SerialNumbers_serialnumbers_lots_dd_ComponentContextService,
    private _elementRef: ElementRef
    ) {
      super();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): number | number[] {
    return this._innerValue;
  }

  set value(val:  number | number[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  displayWithFn(value: any): Promise<{displayText:string, selected :Array<{ key: any; name: string; disabled?: boolean; selected?: boolean;}>}> {
    const promise = new Promise<{displayText:string, selected :Array<{ key: any; name: string; disabled?: boolean; selected?: boolean;}>}>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = null;
      const $fullTextSearch = null;
      this.$datasources.SerialNumbers.ds_handle_serialnumbers_lots_dd.getByKeys({
        $keys: value,
        licenseplateIds:  $selector.inParams.licenseplateIds ,
        locationId:  $selector.inParams.locationId ,
        warehouseIds:  $selector.inParams.warehouseIds ,
        lotId:  $selector.inParams.lotId ,
        materialIds:  $selector.inParams.materialIds ,
        projectId:  $selector.inParams.projectId ,
        ownerId:  $selector.inParams.ownerId ,
        archived:  $selector.inParams.archived ,
        fullTextSearch:  $selector.inParams.fullTextSearch ,
        textSearch:  $selector.inParams.textSearch ,
        orderId:  $selector.inParams.orderId ,
        orderLineNumber:  $selector.inParams.orderLineNumber ,
        selectorSearch:  $selector.fullTextSearch ,
      }).then(result => {
        const selected = value.map(k => {
          const found = result.result
            .find(i => i.LotId === k);
          const e: { LotId?: number, Lookup?: string } = found 
            ?? { 
              LotId : k
            };

          const $option = { entity: e };
          const $entity = e;
          const $resultOption = { key: null, name: found ? $option.entity.Lookup : 'No data to display', disabled: false, selected:true };
          $resultOption.key = $option.entity.LotId;
          return $resultOption;
        });
        const displayText = value.map(k => {
          const found = result.result
            .find(i => i.LotId === k);
          if (found) {
            const $option = { entity: found };
            const $entity = found;
            return $option.entity.Lookup;
          } else {
            return 'No data to display';
          }
        })
        .join(
           ', '
        );
        this.displayTextChange.emit(displayText);
        resolve({displayText, selected});
      });
    });
    return promise;
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {

    const promise = new Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = filterText;
      const $fullTextSearch = filterText;
      this.$datasources.SerialNumbers.ds_handle_serialnumbers_lots_dd.getList({
        $top: 25,
        $skip: 0,
        licenseplateIds:  $selector.inParams.licenseplateIds ,
        locationId:  $selector.inParams.locationId ,
        warehouseIds:  $selector.inParams.warehouseIds ,
        lotId:  $selector.inParams.lotId ,
        materialIds:  $selector.inParams.materialIds ,
        projectId:  $selector.inParams.projectId ,
        ownerId:  $selector.inParams.ownerId ,
        archived:  $selector.inParams.archived ,
        fullTextSearch:  $selector.inParams.fullTextSearch ,
        textSearch:  $selector.inParams.textSearch ,
        orderId:  $selector.inParams.orderId ,
        orderLineNumber:  $selector.inParams.orderLineNumber ,
        selectorSearch:  $selector.fullTextSearch ,
      }).then(result => {
        resolve({
          list: result.result.map(item => {
            const $option = { entity: item };
            const $entity = item;
            const $resultOption = { key: null, name: $option.entity.Lookup, disabled: null };
            $resultOption.key = $option.entity.LotId;
            return $resultOption;
          }),
          totalCount: result.totalCount,
          top: 25
        });
      });

    });

    return promise;

  }

}
